function AudioPlayer(audioelement) {
	this.onDataLoaded = null;
	this.volume = 1;
	this.htmlAudioID = audioelement;
	this.dataLoaded = false;
	this.playAfterLoad = false;

	try {
	  // still needed for Safari
	  window.AudioContext = window.AudioContext || window.webkitAudioContext;

	  // create an AudioContext
	  this.context = new AudioContext();
	  //console.log("AUDIO CREATED");
	  this.audioApiSupport = true;
	} catch(e) {
	  // API not supported
	  this.audioApiSupport = false;
	  this.audioElement = new AudioElement(this.htmlAudioID);
	}	
}

AudioPlayer.prototype.forceAudioElement = function() {
	this.audioApiSupport = false;
	this.audioElement = new AudioElement(this.htmlAudioID);	
}

AudioPlayer.prototype.loadSound = function(url) {

	if (!this.audioApiSupport) {
		this.audioElement.load(url);
		return;
	}

	this.streamURL = url;
	var request = new XMLHttpRequest();
 	request.open('GET', url, true);
 	request.responseType = 'arraybuffer';

 	this.dataLoaded = false;
 	var self = this;

  	request.onload = function() {
  		try {
	    	self.context.decodeAudioData(request.response, function(buffer) {

	      		self.buffer = buffer;
	      		self.dataLoaded = true;

	      		if (self.onDataLoaded != null) self.onDataLoaded();
	      		if (self.playAfterLoad) {
	      			self.play();
	      		}

	    	}, function(err) {
	    		console.log("Can't decode audio data.");
	      		//throw new Error(err);
	    	});
    	} catch(e) {
    		
    	}
  	}

	request.send();	
}

AudioPlayer.prototype.setVolume = function(v) {
	this.volume = v;

	if (!this.audioApiSupport) {
		this.audioElement.setVolume(v);
		console.log("set volume audio element");
		return;
	}

	if (this.volumeNode != undefined) {
		this.volumeNode.gain.value = parseFloat(this.volume);
		//console.log("set volume node gain: " + this.volume);
	}
}

AudioPlayer.prototype.play = function() {
	if (!this.audioApiSupport) {
		this.audioElement.play();
		return;
	}

	this.source = this.context.createBufferSource();
	this.source.buffer = this.buffer;
	
	this.volumeNode = this.context.createGain();
	this.volumeNode.gain.value = this.volume;
	this.source.connect(this.volumeNode);

	this.volumeNode.connect(this.context.destination);
	
	//this.source.connect(this.context.destination);
	//this.source.start(0);
	this.source.loop = false;
	try {
		this.source.noteOn(0);
	} catch(e) {
		this.source.start(0);
	}
}

AudioPlayer.prototype.setLoop = function(b) {
	try {
		this.source.loop = b;
	} catch(e) {

	}
}

AudioPlayer.prototype.playWhenLoaded = function() {
	if (!this.audioApiSupport) {
		this.audioElement.play();
		return;
	}

	if (this.dataLoaded) {
		this.play();
	} else {
		this.playAfterLoad = true;
	}
}

AudioPlayer.prototype.stop = function() {
	if (this.source != undefined) this.source.stop();
	else this.playAfterLoad = false;
}

AudioPlayer.prototype.pause = function() {
	this.source.suspend();	
}

AudioPlayer.prototype.resume = function() {
	this.source.resume();
}